import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsCompanyLoadSchema = withDefaults({
  type: 'pcs-company-load',
  fields: [
    {
      kind: 'attribute',
      name: 'actual',
    },
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'cover',
    },
    {
      kind: 'attribute',
      name: 'provider',
    },
    {
      kind: 'attribute',
      name: 'providerId',
    },
    {
      kind: 'attribute',
      name: 'providerData',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'transitionLog',
    },
    {
      kind: 'belongsTo',
      name: 'pcsCompany',
      type: 'pcs-company',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'pcsProvider',
      type: 'pcs-provider',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'pcsProviderLoad',
      type: 'pcs-provider-load',
      options: {
        async: false,
        inverse: 'pcsCompanyLoads',
      },
    },
  ],
});

export default PcsCompanyLoadSchema;
